var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaperplane = function SvgPaperplane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.298,
    height: 64.333
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 445"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M86.298 0 38.304 40.553l20.385 17.2 7.8 6.581 2.736-8.885Z",
    "data-name": "Path 479"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M86.3 0 0 25.316l26.981 8.942Z",
    "data-name": "Path 480"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141835",
    d: "M86.297 0 26.981 34.258 29.082 59l9.224-18.442Z",
    "data-name": "Path 481"
  }))));
};
export default SvgPaperplane;